import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-warranty-reminder-readonly',
  templateUrl: './warranty-reminder-readonly.component.html',
  styleUrls: ['./warranty-reminder-readonly.component.css']
})
export class WarrantyReminderReadonlyComponent implements OnInit {
  @Input() config: any;
  @Input() isOverride: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  get maintenanceMode() {
    return (this.config && this.config.reminderMaintain && this.config.reminderMaintain.mode === 'once') ? 'Gửi 1 lần' : 'Chu kỳ lặp lại';
  }

  get maintenanceTime() {
    if (!this.config || !this.config.reminderMaintain || !this.config.reminderMaintain.numberTimeNotify) return '';
    const num = this.config.reminderMaintain.numberTimeNotify;
    const unit = this.config.reminderMaintain.timeType === 'DAY' ? 'Ngày' : (this.config.reminderMaintain.timeType === 'MONTH' ? 'Tháng' : 'Năm');
    return `${num} ${unit}`;
  }

  get expiredMode() {
    return (this.config && this.config.reminderExpired && this.config.reminderExpired.mode === 'once') ? 'Gửi 1 lần' : 'Chu kỳ lặp lại';
  }

  get expiredTime() {
    if (!this.config || !this.config.reminderExpired || !this.config.reminderExpired.numberTimeNotify) return '';
    const num = this.config.reminderExpired.numberTimeNotify;
    const unit = this.config.reminderExpired.timeType === 'DAY' ? 'Ngày' : (this.config.reminderExpired.timeType === 'MONTH' ? 'Tháng' : 'Năm');
    return `${num} ${unit}`;
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/components/warranty-reminder/warranty-reminder-readonly/warranty-reminder-readonly.component.ts